import API from '../../services/api.svelte.js';
import { notificate } from '../../services/notification.js';

export function search(config = {}) {
    return API.search('integration', config);
}

export function searchAgent(config = {}) {
    return API.search('v2/agent/installer/', config);
}

export function find(id, config = {}) {
    return API.find('integration', id);
}

export function save(data, files = [], config = {}) {
    return API.save('integration', data, files, config, false)
        .then(async (response) => {
            if (!response.ok) {
                // api validation errors
                let toastConfig = {
                    data: data.email,
                    options : {
                        "timeOut": "0",
                        "extendedTimeOut": "0",
                        "showDuration": "0",
                        "hideDuration": "0",
                        "closeButton": true
                    }
                }
                notificate('save_error', "toast", toastConfig);
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(apiData => {
            notificate('save_ok', "toast", {data: apiData.email});
            apiData.type = 'integration';
            return apiData;
        })
    ;
}

export function del(integration, config = {}) {
    return API.del('integration', integration.id, config)
        .then(async (response) => {
            if (!response.ok) {
                notificate('delete_error', "toast", {data: integration.email});
                let errors = await response.json();
                throw errors;
            }
            return response.json();
        })
        .then(data => {
            notificate('delete_ok', "toast", {data: integration.email});

            return data;
        })
    ;
}

export const originalYAML = `
    services:
        watchtower:
            image: containrrr/watchtower
            restart: unless-stopped
            environment:
                WATCHTOWER_CLEANUP: true # deletes old images
                WATCHTOWER_INCLUDE_RESTARTING: true # update containers even if they are restaring
                WATCHTOWER_POLL_INTERVAL: 86400 # seconds
                WATCHTOWER_LABEL_ENABLE: true # only monitor containers with label enable = true
            volumes:
                - /var/run/docker.sock:/var/run/docker.sock
        vulseek-scanner:
            image: public.ecr.aws/securetia/vulseek/scanner:latest
            restart: unless-stopped
            environment:
                PYTHONUNBUFFERED: 1
                API_URL: ${API.url}
                API_KEY:
            labels:
                - "com.centurylinklabs.watchtower.enable=true"
    `
;

export default {
    search,
    searchAgent,
    find,
    save,
    del,
    originalYAML,
}
